module.exports = __webpack_public_path__ + "static/media/twitter.17598046.svg";